import { PurchaseSuccessfulContent } from 'Modules/purchase/components/PurchaseSuccessfulContent/PurchaseSuccessfulContent'
import { PurchaseLayout } from 'Modules/purchase/layouts/PurchaseLayout/PurchaseLayout'

export const PurchaseSuccessful = () => (
  <PurchaseLayout>
    <PurchaseSuccessfulContent />
  </PurchaseLayout>
)
